cb.define([], function () {

    var PM_pmc_groupBuyingStatusView_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();
            var param = viewmodel.getParams();
            //gridModel.setReadOnly(false);
            gridModel.setShowCheckbox(false);
            gridModel.on('beforeLoad', params => {
                params.id = param.groupBuyingId;
            });
            viewmodel.on('couponclose', function () {
                viewmodel.execute('promotionabandon');
            });
            viewmodel.on('checkorder', function (obj) {
                var index = obj.params.index;
                var orderUrl = viewmodel.get('pmc_groupBuyingStatusView').getCellValue(index, 'orderUrl');
                window.open(orderUrl);
                // location.href = orderUrl;
            });
        }
    };
    try {
        module.exports = PM_pmc_groupBuyingStatusView_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_groupBuyingStatusView_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_groupBuyingStatusView_VM.Extend.js